import React from 'react';
import Sentence from './smallComponent/Sentence';
import Image from './Image';
import Online from '../images/icon-online.svg';
import Simple from '../images/icon-budgeting.svg';
import Fast from '../images/icon-onboarding.svg';
import Open from '../images/icon-api.svg'
import '../style/second.css'

export default function Second(){
    return (
       <div className="sec">
          <Sentence className="shead" header='Why choose Easybank ?' paragraph='We leverage Open Banking to turn your bank account into your finicial hub Control your finance like neve Before.'/>
          
          <div id="services">
          <div className="services">
              <Image className='img' src={Online} />
              <Sentence className='bhead' header='Online Banking' paragraph='Our modern web and mobile app allowss you to keep track of your finanaces where you are in the world'/>
          </div>
          <div className="services">
              <Image className='img' src={Simple} />
              <Sentence className='bhead' header='Simple Budgeting' paragraph='See exactly where your money goes each month. Recieve notifications when youre close to hitting your limits'/>
          </div>
          <div className="services">
              <Image className='img' src={Fast} />
              <Sentence className='bhead' header='fast Onboarding' paragraph='We dont do branches. Open your account in minutes at the comfort of your home. tracking money has never been easier'/>
          </div>
          <div className="services">
              <Image className='img' src={Open} />
              <Sentence className='bhead' header='Open Api' paragraph='Manage your savings, investments, pension and much more from one ccount. Tracking your money has never been easier'/>
          </div>
          </div>
       </div>
    )
}